<template>
  <div class="lms-container">
    <div class="content">
      <!-- Main book icon -->
      <div class="book-icon-container">
        <div class="book-icon" :style="{ backgroundColor: get(getLoggedInUser, 'linked_entity.primary_color') + '40' }">
          <md-icon style="font-size: 64px;" :style="{ color: get(getLoggedInUser, 'linked_entity.primary_color') }"
            >import_contacts</md-icon
          >
        </div>
      </div>

      <!-- Main content -->
      <h1 class="title">LMS Not Enabled</h1>

      <p class="subtitle">
        The Learning Management System feature is currently not enabled for your school.
      </p>

      <p class="description">
        Unlock powerful course management, student tracking, and<br />
        interactive learning tools.
      </p>

      <!-- Contact button -->

      <a
        href="mailto:support@jointransition.com"
        class="contact-btn"
        :style="{ backgroundColor: get(getLoggedInUser, 'linked_entity.primary_color') }"
        target="_blank"
      >
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M20 4H4C2.9 4 2.01 4.9 2.01 6L2 18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V6C22 4.9 21.1 4 20 4ZM20 8L12 13L4 8V6L12 11L20 6V8Z"
            fill="currentColor"
          />
        </svg>
        Contact Administrator
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M5 12H19M19 12L12 5M19 12L12 19"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </a>
      <p class="email mt-4">
        Please reach out to the administrator at
        <a href="mailto:support@jointransition.com" class="text-primary" target="_blank">support@jointransition.com</a>
        to request access.
      </p>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { get } from 'lodash';
export default {
  name: 'LmsDisabled',
  computed: {
    ...mapGetters('auth', ['getLoggedInUser']),
  },
  methods: {
    get,
  },
};
</script>

<style scoped>
.lms-container {
  position: relative;
  min-height: 100vh;
  background: #f8fafc;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 40px 20px;
  overflow: hidden;
}

.bg-decoration {
  position: absolute;
  border: 2px solid rgba(226, 232, 240, 0.6);
  border-radius: 50%;
  pointer-events: none;
}

.accent-circle {
  position: absolute;
  top: 80px;
  right: 80px;
  width: 56px;
  height: 56px;
  background: linear-gradient(135deg, #fbbf24, #f59e0b);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 8px 25px rgba(251, 191, 36, 0.3);
}

.content {
  text-align: center;
  max-width: 600px;
  z-index: 1;
  position: relative;
}

.book-icon-container {
  margin-bottom: 40px;
}

.book-icon {
  width: 120px;
  height: 120px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.2);
}

.title {
  font-size: 2.5rem;
  font-weight: 700;
  color: #1e293b;
  margin-bottom: 24px;
  line-height: 1.2;
}

.subtitle {
  font-size: 1.125rem;
  color: #64748b;
  margin-bottom: 16px;
  line-height: 1.6;
}

.description {
  font-size: 1rem;
  color: #64748b;
  margin-bottom: 40px;
  line-height: 1.6;
}

.contact-btn {
  display: inline-flex;
  align-items: center;
  gap: 12px;
  color: white;
  padding: 16px 32px;
  border: none;
  border-radius: 12px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.2);
  margin-bottom: 16px;
}

.contact-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 12px 35px rgba(0, 0, 0, 0.2);
}

.contact-btn:active {
  transform: translateY(0);
}

.email {
  color: #64748b;
  font-size: 0.9rem;
  margin-bottom: 60px;
}

@media (max-width: 768px) {
  .lms-container {
    padding: 20px;
  }

  .title {
    font-size: 2rem;
  }

  .subtitle,
  .description {
    font-size: 1rem;
  }
}

@media (max-width: 480px) {
  .contact-btn {
    padding: 14px 28px;
    font-size: 0.9rem;
  }
}
</style>
